import React from 'react'
import './App.css';
import { Route, Routes, Outlet } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import Layout from './components/shared/Layout/Layout';
import AthleteSafetyRVPPage from './pages/AthleteSafetyRVPPage';
import MinorAthleteTrainingPage from './pages/MinorAthleteTrainingPage';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';
import TrainingStepByStepPage from './pages/TrainingStepByStepPage';
import CertificatesPage from './pages/CertificatesPage';
import CertificateViewPage from './pages/CertificateViewPage';
import ErrorPage from './pages/ErrorPage';


function App() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path="/Error/:code" element={<ErrorPage />} />
      </Route>
      <Route element={<Layout><Outlet /></Layout>}>
        <Route path="*" element={<DashboardPage />} />
      </Route>
      <Route element={<Layout isGeneric={false}><Outlet /></Layout>}>
        <Route path="/AthleteSafetyRVP" element={<AthleteSafetyRVPPage />} />
      </Route> 
      <Route element={<Layout isGeneric={false}><Outlet /></Layout>}>
        <Route path="/Certificates" element={<CertificatesPage />} />
      </Route>
      <Route element={<Layout isGeneric={false}><Outlet /></Layout>}>
        <Route path="/Certificates/ViewCertificate" element={<CertificateViewPage />}/>
      </Route>
      <Route element={<Layout isGeneric={false}><Outlet /></Layout>}>
        <Route path="/AthleteSafetyRVP/MinorAthleteTraining" element={<MinorAthleteTrainingPage />} />
      </Route> 
      <Route element={<Layout isGeneric={false}><Outlet /></Layout>}>
        <Route path="/AthleteSafetyRVP/TermsAndConditions" element={<TermsAndConditionsPage />} />
      </Route> 
      <Route element={<Layout isGeneric={false}><Outlet /></Layout>}>
        <Route path="/AthleteSafetyRVP/TrainingStepByStep" element={<TrainingStepByStepPage />} />
      </Route>
    </Routes>
  );
}

export default App;
